export const namePlacementKey = 'namePlacement';
export const typePlacementKey = 'typePlacement';
export const clearPlacementKey = 'clearPlacement';
